import * as angular from "angular";
import {IController} from "angular";

export class ExpendButtonComponent implements IController {
  isExpended: any;
  tooltipText: any;
  isMobile: any;

  onToggle: Function;

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('expendButton', {
    bindings: {
      isExpended: '<',
      tooltipText: '@?',
      isMobile: '<?',
      onToggle: '&'
    },
    templateUrl: 'app/modules/commons/components/expend-button/expend-button.html',
    controller: ExpendButtonComponent
  });
